import * as React from 'react';
import { FieldsMappingContext } from '../Context';
import { useProfileTeaserFields } from './hooks';
import Links, { Link } from './profile-teaser/Links';

function SpecializationField({value}) {
  if (Array.isArray(value) && value.length > 0) {
    return value.join(',');
  }
  if (value) {
    return value;
  }
  return '';
}

function ResearchFocusGroup({ specialization, institutionName }) {
  const hasSpecialization = Array.isArray(specialization) ? specialization.length > 0 : !!specialization;
  const hasInstitution = !!institutionName;
  if (!hasSpecialization && !hasInstitution) { return null; }
  return (
    <div className='fields-group'>
      <div className='field field--heading text-bold'>{I18n.t('profile_teasers.research_focus')}</div>
      {hasSpecialization && (
        <div className='field field--heading field--specialization'>
          <SpecializationField value={specialization}/>
        </div>
      )}
      {hasInstitution && (
        <div className='field field--institution-name'>{institutionName}</div>
      )}
    </div>
  );
}

export default function (props) {
  const { hit } = props;
  const { profileTeaser } = React.useContext(FieldsMappingContext);
  const [mapping] = profileTeaser;

  const {
    image,
    links,
    title = null,
    jobRole,
    location,
    specialization = [],
    institutionName,
    extraFields = [],
    pageUrl,
  } = useProfileTeaserFields(hit, mapping);

  return (
    <div className='profile-teaser'>
      <div className='profile-teaser__content'>
        <div className='profile-teaser__image'>
          <img src={image} alt={title} />
        </div>
        <div className='profile-teaser__links'>
          <Links links={links} />
        </div>
        <div className='profile-teaser__fields'>
          <div className='fields-groups'>
            <div className='fields-group'>
              <h3 className='h--smallest field field--title'>{title}</h3>
              {location && <div className='field field--location'>{location}</div>}
              <div className='field field--job-role'>{jobRole}</div>
            </div>

            {extraFields.length > 0 && (
              <div className='fields-group'>
                {extraFields.map(({ key, label, value }) => (
                  <React.Fragment key={key}>
                    <div className='field field--heading text-bold'>{label}</div>
                    <div className='field'>{value}</div>
                  </React.Fragment>
                ))}
              </div>
            )}

            <ResearchFocusGroup specialization={specialization} institutionName={institutionName} />
          </div>
          {pageUrl?.trim() && <a href={pageUrl} className='nv-cta-secondary nv-cta-secondary--small'>{I18n.t('profile_teasers.profile_page')}</a>}
        </div>
      </div>
    </div>
  );
}
